import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Button from "../common/Button";
import TextInput from "../common/TextInput";
import { Modal } from "semantic-ui-react";
import './ConfirmModal.css';

const ConfirmModal = ({ isOpen, title, mainText, confirmAction, disableConfirm, cancelAction, confirmText, cancelText, inputName, inputValue, inputLabel, onChange, errors, validationMessageType, confirmText2, confirmAction2, showOnTop }) => {
	const titleElement = title ? <div className="l-grid__col:12/12"><h2>{title}</h2><br /></div> : null;

	const scrollYSize = window.parent.scrollY;
	let top = 0;
	const confirmHeight = inputName ? 400 : 220;
	const headerHeight = 714;
	let overflowY = 'hidden';
	let maxHeight = window.innerHeight + 20;

	if (!showOnTop) {
		if (window.innerHeight === window.parent.innerHeight) {
			// lokaal
			const x = confirmHeight / 2;
			top = window.innerHeight / 2 - x;
		}
		else {
			const x = headerHeight - scrollYSize + (confirmHeight / 2);
			top = window.parent.innerHeight / 2 - x;
			top = top > (window.innerHeight - confirmHeight * 2) ? window.innerHeight - confirmHeight * 2 : top;
			top = top < (confirmHeight / 2) ? (confirmHeight / 2) : top;
		}
	}
	else {
		top = 20;
		overflowY = 'auto';
	}

	const style = { bottom: 'auto', top: top };

	const showSecondConfirm = confirmAction2;
	const showConfirm = confirmAction;
	const showCancel = cancelAction;

	const cancelButton = showCancel ? <Button className="l-grid__col:2/12" onClick={cancelAction} autoFocus text={cancelText} style={{ float: 'left' }} /> : null;
	const secondConfirmButton = showSecondConfirm ? <Button className="l-grid__col:2/12" onClick={confirmAction2} text={confirmText2} /> : null;
	const confirmButton = showConfirm ? <Button className="l-grid__col:2/12" disabled={disableConfirm} onClick={confirmAction} text={confirmText} style={{ paddingLeft: '5px', width: '22%' }} /> : null;

	return (
		<Modal
			id="TheModalId"
			style={style}
			open={isOpen}>
			<Modal.Content>
				{titleElement}
				<Fragment>
					<div className="l-grid__col:12/12" style={{ overflowX: 'hidden', overflowY: 'auto' }}>{mainText}<br /></div>
					{inputName ?
						<Fragment><br /><TextInput name={inputName} value={inputValue} onChange={onChange} label={inputLabel} validationMessage={errors[inputName]} validationMessageType={validationMessageType} /></Fragment>
						:
						null
					}
				</Fragment>
			</Modal.Content>
			<Modal.Actions className={"c-form__actions"}>
				{cancelButton}{secondConfirmButton}&nbsp;&nbsp;{confirmButton}
			</Modal.Actions>
		</Modal>
	);
};

ConfirmModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	title: PropTypes.string,
	mainText: PropTypes.string.isRequired,
	confirmAction: PropTypes.func,
	cancelAction: PropTypes.func,
	confirmText: PropTypes.string,
	disableConfirm: PropTypes.bool,
	cancelText: PropTypes.string,
	inputName: PropTypes.string,
	onChange: PropTypes.func,
	inputLabel: PropTypes.string,
	inputValue: PropTypes.string,
	errors: PropTypes.object,
	validationMessageType: PropTypes.string,
	confirmAction2: PropTypes.func,
	confirmText2: PropTypes.string,
	showOnTop: PropTypes.bool
};

export default ConfirmModal;
